module.exports = __webpack_public_path__ + "img/default-menu-icon.9c4887cb.svg";